import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import {ModuleCustomizerComponent} from "@irb-common/components/module-customizer/module-customizer.component";

@Component({
  selector: 'irb-module-dynamic-builder',
  templateUrl: './module-dynamic-builder.component.html',
  styleUrl: './module-dynamic-builder.component.scss',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ModuleDynamicBuilderComponent implements OnInit {

  @Input("modulesToBuild") modulesToBuild: Array<any>;
  @Input() globalSettings: any;
  @Output() modulesToSave = new EventEmitter<boolean>();
  isUiTest: boolean = false;

  constructor(public dialog: MatDialog) {

  }

  ngOnInit(): void {
    // console.log('modulesToBuild', this.modulesToBuild);
  }


  openFullScreenDialog(): void {
    const deepCopyOfModules = JSON.parse(JSON.stringify(this.modulesToBuild));
    let moduleType: any;
    deepCopyOfModules.forEach((module: any) => {
      moduleType = this.modulesToBuild.find((m: any) => m.id === module.id)
      if (moduleType)
        module.type = moduleType.type;
    });
    const dialogRef = this.dialog.open(ModuleCustomizerComponent, {
      width: '100%',
      maxWidth: '100vw',
      height: '100%',
      maxHeight: '100vh',
      disableClose: true,
      panelClass: "irb-dialog-module-customizer",
      autoFocus: false,
      data: {modulesToBuild: deepCopyOfModules}
    });

    this.emitAftersave(dialogRef);
  }

  emitAftersave(dialogRef: any) {
    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result)
        return;
      this.modulesToSave.emit(result);
    });
  }
}
